import Vue from "vue";
import Router from "vue-router";
import User from "./views/User.vue";
import Privacy from "./views/Privacy.vue";
import privacyOther from "./views/privacyOther.vue";
import privacyDd from "./views/privacyDd.vue";
import privacyXt from "./views/privacyXt.vue";
import empower from "./views/empower.vue";
import cue from "./views/cueuserDd.vue";
import cuePrivacy from "./views/cuePrivacy.vue";
import empowerdd from "./views/empowerdd.vue";
import privacyThird from "./views/privacyThird.vue";
import recharge from "./views/recharge.vue";
import newUser from "./views/newUser.vue";
import privacyQd from "./views/privacyQd.vue";
import privacyZy from "./views/privacyZy.vue";

Vue.use(Router);
/* eslint-disable */

console.log();
export default new Router({
  routes: [
    {
      path: "/user",
      name: "user",
      component: User
    },
    {
      path: "/recharge",
      name: "recharge",
      component: recharge
    },
    {
      path: "/privacyOther",
      name: "privacyOther",
      component: privacyOther
      // component: () => import( /* webpackChunkName: "Privacy" */ './views/Privacy.vue'),
    },
    {
      path: "/privacyQd",
      name: "privacyQd",
      component: privacyQd 
    },
    {
      path: "/privacyZy",
      name: "privacyZy",
      component: privacyZy 
    },
    {
      path: "/privacyThird",
      name: "privacyThird",
      component: privacyThird
    },
    {
      path: "/realauth",
      name: "RealPersonAuth",
      component: Privacy,
      component: () => import(/* webpackChunkName: "Privacy" */ "./views/realauth.vue")
    },
    {
      path: "/privacy",
      name: "privacy",
      component: Privacy
      // component: () => import( /* webpackChunkName: "Privacy" */ './views/Privacy.vue'),
    },
    {
      path: "/privacyDd",
      name: "privacyDd",
      component: privacyDd
    },
    {
      path: "/privacyXt",
      name: "privacyXt",
      component: privacyXt
    },
    {
      path: "/empower",
      name: "empower",
      component: empower
    },
    {
      path: "/empowerdd",
      name: "empowerdd",
      component: empowerdd
    },
    {
      path: "/cue",
      name: "cue",
      component: cue
    },
    {
      path: "/cuePrivacy",
      name: "cuePrivacy",
      component: cuePrivacy
    },
    {
      path: "/newUser",
      name: "newUser",
      component: newUser
    }
    
  ]
});
